(function () {
  'use strict';
  function setup() {
    document.querySelectorAll('[data-ddc-product]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var product = JSON.parse(root.querySelector('[data-ddc-product-json]').textContent);
      var form = root.querySelector('#ddc-product-form');
      var options = Array.from(root.querySelectorAll('[data-ddc-option]'));
      var variantInput = root.querySelector('[data-ddc-variant-id]');
      var add = root.querySelector('[data-ddc-add]');
      var message = root.querySelector('#ddc-selection-message');
      var price = root.querySelector('[data-ddc-price]');
      var startingPrice = price.textContent;
      var currentVariant = null;
      var sticky = root.querySelector('[data-ddc-sticky]');
      var stickyButton = root.querySelector('[data-ddc-sticky-button]');
      var dynamic = root.querySelector('[data-ddc-dynamic]');
      var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.ddcCurrency || 'USD'});
      options.forEach(function (select) {select.disabled = false;});
      function update(updateUrl) {
        var selected = options.map(function (select) {return select.value;});
        var complete = selected.every(Boolean);
        currentVariant = complete ? product.variants.find(function (variant) {return variant.options.every(function (value, index) {return !options.length || value === selected[index];});}) : null;
        if (!options.length) currentVariant = product.variants[0];
        variantInput.disabled = !currentVariant || !currentVariant.available;
        variantInput.value = currentVariant ? currentVariant.id : '';
        add.disabled = !currentVariant || !currentVariant.available;
        add.textContent = !complete ? 'Choose options' : !currentVariant ? 'Unavailable combination' : currentVariant.available ? 'Add to cart' : 'Sold out';
        message.textContent = !complete ? 'Choose your size and options to check availability.' : !currentVariant ? 'This combination is not offered. Please choose another option.' : !currentVariant.available ? 'This option is currently sold out. Please choose another size or color.' : 'Selected option is available to order.';
        price.textContent = currentVariant ? money.format(currentVariant.price / 100) : startingPrice;
        root.querySelector('[data-ddc-sticky-price]').textContent = root.dataset.ddcHasSubscriptions === 'true' ? root.dataset.ddcSubscriptionFrom : price.textContent;
        root.querySelector('[data-ddc-sku]').textContent = currentVariant && currentVariant.sku ? currentVariant.sku : 'Select an option';
        stickyButton.textContent = root.dataset.ddcHasSubscriptions === 'true' ? 'Purchase options' : currentVariant && currentVariant.available ? 'Add to cart' : 'Choose options';
        if (dynamic) dynamic.hidden = !currentVariant || !currentVariant.available;
        options.forEach(function (select, index) {
          Array.from(select.options).forEach(function (option) {
            if (!option.value) return;
            var matches = product.variants.filter(function (variant) {
              return variant.options[index] === option.value && variant.options.every(function (value, other) {return other === index || !selected[other] || value === selected[other];});
            });
            var suffix = !matches.length ? ' — Not offered with these options' : matches.some(function (variant) {return variant.available;}) ? '' : ' — Sold out';
            option.textContent = option.value + suffix;
          });
        });
        if (updateUrl) {
          var url = new URL(window.location.href);
          if (currentVariant) url.searchParams.set('variant', currentVariant.id); else url.searchParams.delete('variant');
          window.history.replaceState({}, '', url.toString());
        }
        variantInput.dispatchEvent(new Event('change', {bubbles:true}));
      }
      options.forEach(function (select) {select.addEventListener('change', function () {update(true);});});
      form.addEventListener('submit', function (event) {
        if (!currentVariant || !currentVariant.available || !form.reportValidity()) {
          event.preventDefault();
          if (!currentVariant) options.find(function (select) {return !select.value;})?.focus();
        }
      });
      stickyButton.addEventListener('click', function () {
        if (root.dataset.ddcHasSubscriptions === 'true' || root.querySelector('.ddc-buy-row').getBoundingClientRect().top > window.innerHeight) {form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});return;}
        if (currentVariant && currentVariant.available && form.reportValidity()) form.requestSubmit(add);
        else {
          form.scrollIntoView({behavior:'smooth',block:'center'});
          var missing = options.find(function (select) {return !select.value;});
          if (missing) missing.focus({preventScroll:true});
        }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {sticky.hidden = entries[0].isIntersecting || (root.dataset.ddcSkincare !== 'true' && entries[0].boundingClientRect.top > 0);}, {threshold:0}).observe(root.querySelector('.ddc-buy-row'));
      }
      root.querySelectorAll('[data-ddc-photo]').forEach(function (button) {
        button.addEventListener('click', function () {
          var img = root.querySelector('[data-ddc-main-image]');
          img.src = button.dataset.ddcPhoto;
          img.alt = button.dataset.ddcPhotoAlt;
          root.querySelector('[data-ddc-image-link]').href = button.dataset.ddcFullPhoto;
          root.querySelectorAll('[data-ddc-photo]').forEach(function (other) {other.setAttribute('aria-pressed', String(other === button));});
        });
      });
      var dialog = root.querySelector('[data-ddc-chart]');
      var opener = root.querySelector('[data-ddc-open-chart]');
      if (dialog && opener && typeof dialog.showModal === 'function') {
        opener.addEventListener('click', function (event) {event.preventDefault();dialog.showModal();});
        root.querySelector('[data-ddc-close-chart]').addEventListener('click', function () {dialog.close();});
        dialog.addEventListener('click', function (event) {if (event.target === dialog) dialog.close();});
      }
      update(false);
    });
    document.querySelectorAll('.ddc-nav-group').forEach(function (group) {
      if (group.dataset.ready) return;
      group.dataset.ready='true';
      group.addEventListener('toggle', function () {if (group.open) document.querySelectorAll('.ddc-nav-group').forEach(function (other) {if (other !== group) other.open = false;});});
    });
    var feedbackProduct = document.getElementById('ddc-contact-product');
    var productParam = new URLSearchParams(window.location.search).get('product');
    if (feedbackProduct && productParam && !feedbackProduct.value) feedbackProduct.value = productParam;
  }
  document.addEventListener('keydown', function (event) {if (event.key === 'Escape') document.querySelectorAll('.ddc-nav-group[open]').forEach(function (group) {group.open = false;});});
  document.addEventListener('click', function (event) {if (!event.target.closest('.ddc-nav-group')) document.querySelectorAll('.ddc-nav-group[open]').forEach(function (group) {group.open = false;});});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup); else setup();
  document.addEventListener('page:load',setup);
  window.addEventListener('pageshow',setup);
}());
